<template>
  <div id="nationalVideoDetail">
    <page-header :noBack="true">
      视频详情
    </page-header>
    <div class="video_wrap">
      <video
        class="video"
        :src="infor.vedioUrl"
        :poster="infor.coverImg"
        controls
        ref="video"
        width="100%"
        height="100%"
        playsinline="true"
        x5-playsinline="true"
        webkit-playsinline="true"
        x-webkit-airplay="true"
        x5-video-player-type="h5"
        x5-video-player-fullscreen="true"
        @click="videoPlay"
        @play="getPlay"
        @pause="getPause"
        @ended="playEnd"></video>
      <div class="title">{{infor.title}}</div>
      <div class="btns" @click="videoPlay" v-if="!isPlay">
        <img src="../assets/img/icon_start.png" alt="">
      </div>
    </div>
    <div class="infor_wrap">
      <div class="infor">
        <div class="headimgs">
          <img class="headimg" :src="infor.logoUrl" alt="">
        </div>
        <div class="name">{{infor.name}}</div>
      </div>
      <router-link to="/download" tag="div" class="btn">关注</router-link>
    </div>
    <div class="public_no_data">暂无评论</div>
    <div class="download_wrap">
      <div class="left_wrap">
        <img class="logo" src="../assets/img/logo_1.png" alt="">
        <div class="name">学习国防</div>
      </div>
      <router-link to="/download" tag="div" class="btn">下载App</router-link>
    </div>
  </div>
</template>
<script>
export default {
  name: "nationalVideoDetail",
  data() {
    return {
      id: this.$route.query.id,
      isPlay: false,
      infor: {}
    };
  },
  watch: {
    isPlay () {
      if (this.isPlay) {
        this.$refs.video.play();
      } else {
        this.$refs.video.pause();
      }
    },
  },
  mounted () {
    this.getInfo();
  },
  methods: {
    getInfo () {
      this.axios.post('/xxgf-api/api/nationaldefense/shareVedioDetail', {
        id: this.id
      })
        .then(({data}) => {
          if (data.code === 200) {
            this.infor = data.data;
          }
        })
    },
    videoPlay () {
      this.isPlay = true;
    },
    getPlay () {
      this.isPlay = true;
    },
    getPause () {
      this.isPlay = false;
    },
    playEnd () {
      this.isPlay = false;
    }
  }
};
</script>

<style lang="scss">
#nationalVideoDetail {
  width: 100%;
  padding-top:94px;
  padding-bottom:120px;
  .video_wrap{
    width:100%;
    height:420px;
    position:relative;
    color:#fff;
    background:#000;
    .cover_img{
      width:100%;
      height:100%;
      object-fit: cover;
    }
    .title{
      width:100%;
      height:80px;
      line-height:80px;
      padding:0 30px;
      position:absolute;
      left:0;
      top:0;
      z-index:1;
      background:linear-gradient(180deg, rgba($color: #000000, $alpha: 0.5), rgba($color: #000000, $alpha: 0))
    }
    .nums{
      position:absolute;
      left:0;
      bottom:0;
      z-index:2;
      line-height:80px;
      padding:0 30px;
      font-size:24px;
    }
    .btns{
      width:80px;
      height:80px;
      border-radius: 50%;
      background:rgba($color: #000000, $alpha: 0.5);
      padding: 20px;
      position:absolute;
      top:50%;
      left:50%;
      z-index:3;
      transform: translate(-50%, -50%);
      img{
        width:40px;
        height:40px;
        display:block;
      }
    }
  }
  .infor_wrap{
    height:120px;
    display:flex;
    align-items: center;
    justify-content: space-between;
    padding:0 30px;
    background:#fff;
    .infor{
      display:flex;
      align-items: center;
      .headimgs{
        width:66px;
        height:66px;
        border-radius: 50%;
        overflow: hidden;
        margin-right:20px;
        .headimg{
          width:100%;
          height:100%;
          object-fit: cover;
        }
      }
      .name{
        font-size:28px;
      }
    }
    .btn{
      width:150px;
      height:50px;
      background:#D72F1D;
      color:#fff;
      font-size:24px;
      line-height:50px;
      text-align:center;
      border-radius: 30px;
    }
  }
}
</style>
